<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>

    <div class="cv-item">
      <div class="cv-chart" v-if="timesData.length > 0">
        <div class="cv-title">
          <div class="cv-title-item">
            <div class="cv-title-item__name">服务老人人次（万人次）</div>
            <div class="cv-title-item__value">{{ serviceTimes }}</div>
          </div>
        </div>
        <v-chart
          ref="timesChart"
          :options="timesOption"
          @mouseover="onMouseOver('times')"
          @globalout="onGlobalOut('times')"
          autoresize
        ></v-chart>
      </div>
      <div v-else class="cv-nodata">暂无数据!</div>
    </div>
    <div class="cv-item">
      <div class="cv-chart" v-if="staffData.length > 0">
        <div class="cv-title">
          <div class="cv-title-item">
            <div class="cv-title-item__name">从业人数（人）</div>
            <div class="cv-title-item__value">{{ staffNum }}</div>
          </div>
          <div class="cv-title-item">
            <div class="cv-title-item__name">护理员平均年龄（岁）</div>
            <div class="cv-title-item__value">{{ staffAge }}</div>
          </div>
        </div>
        <v-chart
          ref="staffChart"
          :options="staffOption"
          @mouseover="onMouseOver('staff')"
          @globalout="onGlobalOut('staff')"
          autoresize
        ></v-chart>
      </div>
      <div v-else class="cv-nodata">暂无数据!</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'

export default {
  name: 'ServiceTimes',
  computed: {
    ...mapGetters(['cid']),
    timesChart() {
      return this.$refs.timesChart && this.$refs.timesChart['chart']
    },
    staffChart() {
      return this.$refs.staffChart && this.$refs.staffChart['chart']
    },
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '养老服务人次及从业人员统计',
    },
  },
  watch: {
    timesData(data) {
      this.timesOption.dataset.source = data
      this.$nextTick(() => {
        this.timesChart && this.startAnimation('times')
      })
    },
    staffData(data) {
      this.staffOption.dataset.source = data
      this.$nextTick(() => {
        this.staffChart && this.startAnimation('staff')
      })
    },
  },
  data() {
    return {
      serviceTimes: 39.4,
      staffNum: 169,
      staffAge: 42,
      timesIndex: -1,
      timesInterval: null,
      timesData: [],
      timesOption: {
        color: ['#004be3', '#e36b00', '#00e370', '#00afe3', '#e3db00', '#db00e3'],
        legend: {
          show: true,
          top: 'middle',
          right: 'right',
          orient: 'vertical',
          itemWidth: 10,
          itemHeight: 5,
          textStyle: {
            color: '#fff',
            fontSize: 10,
          },
        },
        dataset: {
          source: [],
        },
        series: [
          {
            type: 'pie',
            name: '服务人次统计',
            legendHoverLink: false,
            center: ['35%', '50%'],
            radius: ['50%', '70%'],
            label: {
              show: false,
              padding: [10, 0, 0],
              position: 'center',
              align: 'center',
              fontSize: 12,
              formatter: (params) => {
                return `${params.name}\n{num|${params.data.value}}`
              },
              emphasis: {
                show: true,
                fontSize: 12,
              },
              rich: {
                num: {
                  fontSize: 16,
                  lineHeight: 20,
                },
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#0096ff',
            },
            encode: {
              itemName: 'name',
              value: 'value',
            },
          },
        ],
      },
      staffIndex: -1,
      staffInterval: null,
      staffData: [],
      staffOption: {
        color: ['#004be3', '#e36b00', '#00e370', '#00afe3', '#e3db00', '#db00e3'],
        legend: {
          show: true,
          top: 'middle',
          right: '8%',
          orient: 'vertical',
          itemWidth: 10,
          itemHeight: 5,
          textStyle: {
            color: '#fff',
            fontSize: 10,
          },
        },
        dataset: {
          source: [],
        },
        series: [
          {
            type: 'pie',
            name: '从业人员统计',
            legendHoverLink: false,
            center: ['35%', '50%'],
            radius: ['50%', '70%'],
            label: {
              show: false,
              padding: [10, 0, 0],
              position: 'center',
              align: 'center',
              fontSize: 12,
              formatter: (params) => {
                return `${params.name}\n{num|${params.data.value}}`
              },
              emphasis: {
                show: true,
                fontSize: 12,
              },
              rich: {
                num: {
                  fontSize: 16,
                  lineHeight: 20,
                },
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: '#0096ff',
            },
            encode: {
              itemName: 'name',
              value: 'value',
            },
          },
        ],
      },
    }
  },
  created() {
    this.getServiceStatisData()
  },
  beforeDestroy() {
    if (this.timesInterval) {
      clearInterval(this.timesInterval)
      this.timesInterval = null
    }
    if (this.staffInterval) {
      clearInterval(this.staffInterval)
      this.staffInterval = null
    }
  },
  methods: {
    onMouseOver(chart) {
      if (chart === 'times') {
        if (this.timesInterval) {
          this.timesChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.timesIndex,
          })
          clearInterval(this.timesInterval)
          this.timesInterval = null
        }
      } else {
        if (this.staffInterval) {
          this.staffChart.dispatchAction({
            type: 'downplay',
            seriesIndex: 0,
            dataIndex: this.staffIndex,
          })
          clearInterval(this.staffInterval)
          this.staffInterval = null
        }
      }
    },
    onGlobalOut(chart) {
      if (chart === 'times') {
        !this.timesInterval && this.startAnimation(chart)
      } else {
        !this.staffInterval && this.startAnimation(chart)
      }
    },
    startAnimation(chart) {
      if (chart === 'times') {
        const dataLen = this.timesData.length
        if (dataLen > 1) {
          this.timesInterval = setInterval(() => {
            this.timesChart.dispatchAction({
              type: 'downplay',
              seriesIndex: 0,
              dataIndex: this.timesIndex,
            })
            if (this.timesIndex < dataLen - 1) {
              this.timesIndex++
            } else {
              this.timesIndex = 0
            }
            this.timesChart.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex: this.timesIndex,
            })
          }, 3000)
        }
      } else {
        const dataLen = this.staffData.length
        if (dataLen > 1) {
          this.staffInterval = setInterval(() => {
            this.staffChart.dispatchAction({
              type: 'downplay',
              seriesIndex: 0,
              dataIndex: this.staffIndex,
            })
            if (this.staffIndex < dataLen - 1) {
              this.staffIndex++
            } else {
              this.staffIndex = 0
            }
            this.staffChart.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex: this.staffIndex,
            })
          }, 3000)
        }
      }
    },
    getServiceStatisData() {
      this.$api
        .getElderServiceStatis()
        .then((res) => {
          if (!res) return
          this.serviceTimes = res.JGServiceElderCount
          this.staffAge = res.EmployeeHLYAge
          this.staffNum = res.EmployeeCount
          this.timesData = [
            {
              name: '高龄',
              value: Number(res.JGServiceElderGLCount),
            },
            {
              name: '失能',
              value: Number(res.JGServiceElderSNCount),
            },
            {
              name: '残疾',
              value: Number(res.JGServiceElderCJCount),
            },
            {
              name: '空巢独居',
              value: Number(res.JGServiceElderKCCount),
            },
            {
              name: '特困及低保',
              value: Number(res.JGServiceElderTKCount),
            },
            {
              name: '计划生育特困',
              value: Number(res.JGServiceElderJHCount),
            },
          ]
          this.staffData = [
            {
              name: '护理员',
              value: Number(res.EmployeeHLYCount),
            },
            {
              name: '管理人员',
              value: Number(res.EmployeeGLCount),
            },
            {
              name: '其他人员',
              value: Number(res.EmployeeQTCount),
            },
          ]
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.cv-item {
  display: inline-block;
  width: 50%;
  height: 100%;

  .cv-chart {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    height: 100%;

    .echarts {
      flex: 1;
      width: 100%;
      // height: 100%;
    }
  }

  .cv-title {
    display: flex;
    align-items: center;
    width: 100%;
    // position: absolute;
    // top: 0;
    // left: 20px;

    &-item {
      padding-left: 20px;
      @include text-ellipsis-single;

      &__name {
        color: #fa7310;
        font-size: 12px;
      }

      &__value {
        margin-top: 5px;
        color: #00a4f0;
        font-size: 22px;
        font-weight: 600;
      }
    }
  }
}
</style>
